import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { StatusBadge } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Store, LogOut, Crown } from "lucide-react";

export default function Profile() {
  const { profile, user, logout, refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) return;
    let n = 0;
    const poll = async () => {
      n += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { toast.success("Pro activated"); await refresh(); window.history.replaceState({}, "", "/retailer/profile"); return; }
      } catch {}
      if (n < 10) setTimeout(poll, 2000);
    };
    poll();
  }, [refresh]);

  if (!profile) return null;
  const rows = [
    ["Owner", profile.owner_name], ["Mobile", user?.mobile], ["Email", user?.email || "—"],
    ["Business type", profile.business_type], ["Store type", profile.store_type || "—"],
    ["GSTIN", profile.gstin || "—"], ["Location", profile.location || profile.city],
  ];

  return (
    <div className="mx-auto max-w-xl space-y-5">
      <div className="rounded-xl border border-border bg-card p-6">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-forest text-white"><Store className="h-6 w-6" /></div>
          <div>
            <h1 className="font-heading text-xl font-semibold text-forest">{profile.shop_name}</h1>
            <div className="flex items-center gap-2"><StatusBadge status={profile.verification_status} />
              {profile.premium && <span className="inline-flex items-center gap-1 rounded-full bg-lime px-2 py-0.5 text-xs font-semibold text-ink"><Crown className="h-3 w-3" /> Premium</span>}</div>
          </div>
        </div>
        <dl className="mt-5 divide-y divide-border">
          {rows.map(([k, v]) => (
            <div key={k} className="flex justify-between py-2.5 text-sm"><dt className="text-ink/50">{k}</dt><dd className="text-right text-ink">{v}</dd></div>
          ))}
        </dl>
      </div>

      {!profile.premium && (
        <div className="rounded-xl border border-lime bg-psage/30 p-5">
          <div className="flex items-center gap-2 text-forest"><Crown className="h-5 w-5" /><span className="font-heading text-lg font-medium">Retailer Pro</span></div>
          <p className="mt-1 text-sm text-ink/70">Unlock priority support, margin analytics and purchase recommendations for <b className="num">₹999/mo</b>.</p>
          <Button data-testid="buy-premium" className="mt-3 bg-forest text-white hover:bg-forest/90" onClick={() => nav("/retailer/subscription")}>View plans</Button>
        </div>
      )}

      <Button data-testid="profile-logout" variant="outline" className="w-full border-red-300 text-red-600 hover:bg-red-50" onClick={() => { logout(); nav("/"); }}>
        <LogOut className="mr-2 h-4 w-4" /> Log out
      </Button>
    </div>
  );
}
